export const SelectFSLightBoxActions = {
    SHOW: 'SHOW',
    ERROR: 'ERROR',
    HIDE: 'HIDE',
};
